import { render, staticRenderFns } from "./settings-major.vue?vue&type=template&id=4528ca82"
import script from "./settings-major.vue?vue&type=script&lang=js"
export * from "./settings-major.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports